import { Tooltip } from '@material-ui/core'
import { Info } from '@styled-icons/material-rounded/Info'
import * as S from './index.style'

export type FieldInfoProps = {
  title: string
  dataCy: string
}
export const FieldInfo: React.FC<FieldInfoProps> = ({ title, dataCy }) => {
  return (
    <Tooltip title={title} placement="top-start" arrow data-cy={dataCy}>
      <S.IconButtonVerde>
        <Info size={20} />
      </S.IconButtonVerde>
    </Tooltip>
  )
}

export default FieldInfo
